import { Block, Flex, Typography } from '@aloft/toolkit-sui';

import React from 'react';

type MapAlertProps = {
  children: React.ReactNode;
};

export function MapAlert({ children }: MapAlertProps) {
  return (
    <Flex position="absolute" top="20px" width="100%" justifyContent="center">
      <Block
        zIndex="1"
        paddingX="16px"
        paddingY="4px"
        backgroundColor="surfaceAccent2"
        borderRadius="50px"
      >
        {typeof children === 'string' ? (
          <Typography color="textOffset">{children}</Typography>
        ) : (
          children
        )}
      </Block>
    </Flex>
  );
}
